// extracted by mini-css-extract-plugin
export var clauseRow = "_fj-6";
export var emptyState = "_fj-d";
export var filterContent = "_fj-a";
export var filterGroup = "_fj-1";
export var filterGroupContainer = "_fj-0";
export var nestedGroup = "_fj-2";
export var nestedGroupContent = "_fj-b";
export var nestedGroupDepth1 = "_fj-3";
export var nestedGroupDepth2 = "_fj-4";
export var nestedGroupDepth3 = "_fj-5";
export var nestedGroupEmpty = "_fj-c";
export var operatorAnd = "_fj-8";
export var operatorOr = "_fj-9";
export var operatorToggle = "_fj-7";
export var removeGroupButton = "_fj-e";